export interface IDisposable<T = void> {
    dispose(): T;
}
